@if ($isMenuAllowed() && !$isHiddenForGuest()) {
    @if ($isMenuExpandable()) {
        <div class="toggle-main-menu">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    } @else if ($isMenuConstantlyExpanded()) {
        <ul static-main-menu
            [menuItems]="$menuItems()"
            [logout]="$isAuth() ? logoutFn : undefined">
        </ul>
    }
}
